/**
 * AP Software
 * AP Software REST API.
 *
 * OpenAPI spec version: 3.5.0
 * Contact: support@ap-software.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Comment } from './comment';
import { DataObject } from './dataObject';
import { Team } from './team';

export interface Document { 
    attachments?: Array<DataObject>;
    comments?: Array<Comment>;
    created?: Date;
    documentStatus?: Document.DocumentStatusEnum;
    eTag?: string;
    id?: number;
    index?: number;
    name?: string;
    team?: Team;
    text?: string;
    updated?: Date;
    uploadedFiles?: Array<DataObject>;
    version?: number;
}
export namespace Document {
    export type DocumentStatusEnum = 'UNDECIDED' | 'ACCEPTED' | 'DENIED';
    export const DocumentStatusEnum = {
        UNDECIDED: 'UNDECIDED' as DocumentStatusEnum,
        ACCEPTED: 'ACCEPTED' as DocumentStatusEnum,
        DENIED: 'DENIED' as DocumentStatusEnum
    };
}